// extracted by mini-css-extract-plugin
export default {"FavouritesPage":"FavouritesPage_FavouritesPage__aD7or","favourites_list":"FavouritesPage_favourites_list__Jz-oq","favourites_title":"FavouritesPage_favourites_title__bE0Jn"};